/*global REACT_APP_SALESFORCE_ACCOUNT_URL:true, REACT_APP_SALESFORCE_CONTACT_URL:true*/
import React from "react";
import { SALESFORCE_TYPE } from "@/utils/enum";

export default function SalesForceLink({ externalId, type }) {
  const link =
    type === SALESFORCE_TYPE.ACCOUNT
      ? REACT_APP_SALESFORCE_ACCOUNT_URL.replace("<id>", externalId)
      : REACT_APP_SALESFORCE_CONTACT_URL.replace("<id>", externalId);

  return (
    <a href={link} target="_blank" style={{ textDecoration: "underline" }}>
      {externalId}
    </a>
  );
}
